import type { ColumnDef } from '@tanstack/react-table';

import type { GetPriceInvisibilityRulesQuery } from 'data/__generated__';
import { dateColumn, numberColumn, textColumn } from 'components/DataTable';

export type PriceInvisibilityRuleRow = GetPriceInvisibilityRulesQuery['priceInvisibilityRules'][number];

// Les organisations et les produits ne sont pas nommés ici : ce serait un N+1 par ligne, et le nom de
// la règle porte déjà l'information métier (« Consommables café — Groupe Avril »). Les noms sont
// résolus sur la fiche, par les selects eux-mêmes.
export const priceInvisibilityRulesColumns: ColumnDef<PriceInvisibilityRuleRow, unknown>[] = [
    textColumn<PriceInvisibilityRuleRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
    numberColumn<PriceInvisibilityRuleRow, Record<string, unknown>>({
        id: 'organizationsCount',
        accessorFn: (row) => row.organizationIds.length,
        header: 'Organisations',
        defaultVisible: true,
    }),
    numberColumn<PriceInvisibilityRuleRow, Record<string, unknown>>({
        id: 'productsCount',
        accessorFn: (row) => row.productIds.length,
        header: 'Produits masqués',
        defaultVisible: true,
    }),
    dateColumn<PriceInvisibilityRuleRow, Record<string, unknown>>({
        accessorKey: 'updatedAt',
        header: 'Modifiée le',
        defaultVisible: true,
    }),
];
